"use client";
import Image from "next/image";

export const SpandaDAT = ({  isMobile }) => {
  const dots = [
    {
      dotTop: "12%",
      dotLeft: "46%",
      boxTop: isMobile ? "11%" : "12%",
      boxLeft: "48%",
      fadeStart: isMobile ? 10 : 150,
      fadeEnd: isMobile ? 50 : 200,
      content: (
        <div>
          <h3
            className="mb-2 text-lg font-bold"
            style={{ fontSize: isMobile ? "12px" : "16px" }}
          >
            High Quality Chest Piece
          </h3>
          <p>High Tech microphone for low frequency sound detection.</p>
        </div>
      ),
    },
    {
      dotTop: "26%",
      dotLeft: "80%",
      boxTop: "28%",
      boxLeft: isMobile ? "50%" : "78%",
      fadeStart: isMobile ? 100 : 400,
      fadeEnd: isMobile ? 150 : 450,
      content: (
        <div>
          <h3
            className="mb-2 text-lg font-bold"
            style={{ fontSize: isMobile ? "12px" : "16px" }}
          >
            High Amplification for clear hearing
          </h3>
          <ul className="list-disc pl-6">
            <li>Soft Silicon Earbud.</li>
            <li>Custom designed speakers for low frequency sounds.</li>
          </ul>
        </div>
      ),
    },
    {
      dotTop: "44%",
      dotLeft: "32%",
      boxTop: "46%",
      boxright: isMobile ? "52%" : "67%",
      fadeStart: isMobile ? 200 : 700,
      fadeEnd: isMobile ? 300 : 800,
      content: (
        <div>
          <h3
            className="mb-2 text-lg font-bold"
            style={{ fontSize: isMobile ? "12px" : "16px" }}
          >
            User friendly Operation Console
          </h3>
          <ul className="list-disc pl-6">
            <li>Long life battery</li>
            <li>Ease of use with Indications & Tactile buttons</li>
            <li>Focus Modes (Cardiac, Pulmonary and Wide)</li>
            <li>Audio Recording and Sharing Service</li>
            <li>Live Streaming</li>
            <li>AI for arrhythmia prediction</li>
            <li>OTA updates</li>
          </ul>
        </div>
      ),
    },
    {
      dotTop: "70%",
      dotLeft: "90%",
      boxTop: "71%",
      boxLeft: isMobile ? "70%" : "85%",
      fadeStart: isMobile ? 250 : 1100,
      fadeEnd: isMobile ? 150 : 1300,
      content: (
        <div>
          <h3
            className="mb-2 text-lg font-bold"
            style={{ fontSize: isMobile ? "12px" : "16px" }}
          >
            Tubing
          </h3>
          <ul className="list-disc pl-6">
            <li>Durable</li>
            <li>Latex free</li>
            <li>Easy to use</li>
          </ul>
        </div>
      ),
    },
  ];
  return (
    <div style={{ backgroundColor: "#ffffff" }}>
<div className="flex items-start gap-8">
  <div className="w-full h-full relative flex flex-col items-center justify-center overflow-hidden">
    
    {/* Logo */}
    <Image
      src="/images/logo/SpandaDATCrop.jpeg"
      alt="Spanda DAT"
      width={500}
      height={0}
      className="animate-pop-in"
    />

    {/* Background Image + Fade + Content */}
    <div
      className="
        relative mt-10 w-full rounded-lg p-10 md:p-48 text-white 
        bg-cover bg-center bg-no-repeat min-h-[600px]
        bg-[url('/images/products/LIVE_AUSCULTATION_SAD.jpg')]
        before:absolute before:inset-0 before:bg-black/70 before:z-0
      "
    >

      <div className="relative z-10">
        <h2 className="text-teal-400 font-bold text-xl text-center pt-6">
          Live Auscultation. Amplified Learning.
        </h2>
        <p className="mt-2 text-center">
          Spanda DAT empowers professors to deliver immersive and collaborative
          training sessions like never before.
        </p>

        <h3 className="mt-4 text-green-400 font-semibold text-lg">How it works:</h3>
        <ol className="list-decimal list-inside mt-2 space-y-2">
          <li>
            <strong>Professor Device (Spanda Transmitter)</strong><br />
            The lead professor uses a <strong>Spanda Digital Stethoscope</strong> 
            connected to the <strong>Spanda App</strong> on a tablet.
          </li>
          <li>
            <strong>Seamless Connectivity</strong><br />
            Auscultation audio is transmitted instantly via a 
            <strong> dedicated Wi-Fi network</strong>.
          </li>
          <li>
            <strong>Student Device (Spanda Receiver)</strong><br />
            Each student listens to <strong>exactly what the professor hears</strong>, 
            simultaneously.
          </li>
        </ol>

        <h3 className="mt-6 text-green-400 font-semibold text-lg">Key Benefits:</h3>
        <ul className="list-disc list-inside mt-2 space-y-2">
          <li>
            <strong>Real-Time Auscultation for All Students</strong><br />
            Every student hears the same sounds as the professor in real time.
          </li>
          <li>
            <strong>Better Clinical Training</strong><br />
            Students accurately learn to identify heart & lung sounds.
          </li>
          <li>
            <strong>Supports Audio - Visual Integration</strong><br />
            Pairing auscultation audio with visuals improves learning.
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>

      {/* Text */}
      <div className="flex flex-col items-center gap-4">
        {/* Image */}
        <div style={{ paddingTop: "40px" }}>
          <Image
            src="/images/products/TROLLY.png"
            alt="Trolley"
            width={350}
            height={0}
          />
        </div>
        {/* Text Section 1 START */}
        {/* <div className="text-left text-gray-800 max-w-[700px] p-8 w-full flex flex-col items-center"> */}
        <div
            className="mt-6 w-full max-w-none text-left text-black rounded-lg p-8"
            style={{
              backgroundColor: "#ffffffff",
              margin: "0 auto",
              color: "black",
            }}
          >
          <p className="text-sm text-gray-500 w-full">
        <strong>Note:</strong> Actual Trolley may differ from the image.
          </p>

          <h3 className="mt-4 text-teal-500 font-semibold text-lg w-full text-left">System Highlights</h3>

          <ul className="list-disc list-inside mt-2 space-y-4 w-full">
        <li>
          <strong>Comprehensive Package</strong><br />
          Includes a Spanda Elite Stethoscope (transmitter), an Android tablet,
          receiver packs (available in <strong>10, 15, or 20 units</strong>) and WiFi router.
        </li>

        <li>
          <strong>Professor Command Centre</strong><br />
          The DAT app on the tablet enables professors to 
          <strong> f  acilitate training, conduct evaluations,</strong> and 
          <strong> screencast phonocardiograms</strong> on larger displays (TVs or projectors).
        </li>

        <li>
          <strong>Fully Mobile Design</strong><br />
          Comes with a <strong>wheeled trolley</strong> that houses a built-in charging station 
          for secure storage and easy recharging of receivers.
        </li>

        <li>
          <strong>Independent Wireless Setup</strong><br />
          Operates on a <strong>dedicated wireless network</strong> — no external internet required, 
          making it ideal for <strong>rural areas and high-security environments.</strong>
        </li>
          </ul>
        </div>
        {/* Text Section 1 END */}
      </div>
    </div>
  );
};

export default SpandaDAT;
